import { render, staticRenderFns } from "./notice_table.vue?vue&type=template&id=6fe163c6&scoped=true&"
import script from "./notice_table.vue?vue&type=script&lang=js&"
export * from "./notice_table.vue?vue&type=script&lang=js&"
import style0 from "./notice_table.vue?vue&type=style&index=0&id=6fe163c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe163c6",
  null
  
)

export default component.exports